import React, { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'
import { Container, Paragraph, Logo } from '@scentregroup/ui'
import {
  RESPONSIBLE_BUSINESS,
  RESPONSIBLE_BUSINESS_REPORT,
  SCENTRE_GROUP_HOME,
} from '../paths'
import { FooterSection } from './footer-section'
import style from './index.module.scss'

export interface ILink {
  label: string
  href: string
}

interface ISiteFooterProps {
  className?: string | null
  showAngle?: boolean
  colour?: 'brand' | 'seasonal'
  children: ReactNode
  links: ILink[]
}

export const SiteFooter = ({
  className = null,
  colour = 'seasonal',
  children,
  links = [],
  showAngle = true,
}: ISiteFooterProps): ReactElement => (
  <footer
    className={classNames(style.siteFooter, className, {
      [style.showAngle]: showAngle,
      [style.seasonal]: showAngle && colour === 'seasonal',
      [style.brand]: showAngle && colour === 'brand',
    })}
    role="contentinfo"
  >
    <Container className={style.container} type="large">
      <Logo type="alt" className={style.logo} />
      {children && <FooterSection>{children}</FooterSection>}
      <FooterSection className={style.linksSection}>
        <Paragraph className={style.responsibleBusinessSection}>
          Scentre Group operates its Westfield Living Centre portfolio with a{' '}
          <a href={RESPONSIBLE_BUSINESS}>responsible business</a> mindest across
          the four pillars of community, people, environment and economic
          performance. More information can be found in our{' '}
          <a className={style.highlight} href={RESPONSIBLE_BUSINESS_REPORT}>
            2020 Responsible Business Report
          </a>
          .
        </Paragraph>
        <div className={style.linksWrapper}>
          {links && (
            <ul className={style.linksList}>
              {links.map(({ label, href }) => (
                <li key={href}>
                  <a href={href} className={style.link}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          )}
          <span className={style.rightsText}>
            © All rights reserved{' '}
            <a href={SCENTRE_GROUP_HOME} className={style.highlight}>
              Scentre Group
            </a>{' '}
            {new Date().getFullYear()}
          </span>
        </div>
      </FooterSection>
    </Container>
  </footer>
)
